import { render, staticRenderFns } from "./r-firefly-v2-dialog.vue?vue&type=template&id=b8a44a1e&scoped=true"
import script from "./r-firefly-v2-dialog.vue?vue&type=script&lang=js"
export * from "./r-firefly-v2-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-firefly-v2-dialog.vue?vue&type=style&index=0&id=b8a44a1e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a44a1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8a44a1e')) {
      api.createRecord('b8a44a1e', component.options)
    } else {
      api.reload('b8a44a1e', component.options)
    }
    module.hot.accept("./r-firefly-v2-dialog.vue?vue&type=template&id=b8a44a1e&scoped=true", function () {
      api.rerender('b8a44a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/firefly/r-firefly-v2-dialog.vue"
export default component.exports